<template>
  <div class="content">
    <div class="nav">
      <div>{{title}}</div>
    </div>

    <div class="main">
      <div class="left">
        <div>
          <div class="tit">
            <div></div>
            设备TOP10
          </div>

          <div id="deviceTop"></div>
        </div>
        <div>
          <div class="tit">
            <div></div>
            商品TOP5
          </div>

          <div id="shopTop"></div>
					<!-- <div id="place"></div> -->
        </div>
        <div>
          <div class="tit">
            <div></div>	
            设备支付占比
          </div>
          <div id="pay">
            <div class="box">
              <div
                class="bg"
                v-for="(item, index) in payList"
                :key="index"
                :style="{
                  width: boxWidth * 0.2 * (4 - index) + 'px',
                  height: boxWidth * 0.2 * (4 - index) + 'px',
                }"
              >
                <div></div>
              </div>

              <div
                class="border"
                v-for="(it, idx) in payList"
                :key="it.name"
                :style="{
                  width: boxWidth * 0.2 * (4 - idx) + 'px',
                  height: boxWidth * 0.2 * (4 - idx) + 'px',
                }"
              >
                <div>
                  <div
                    :style="{
                      width: boxWidth * 0.2 * (4 - idx) + 'px',
                      height: boxWidth * 0.2 * (4 - idx) + 'px',
                      borderLeftColor: borderColorList[idx],
                      borderBottomColor: borderColorList[idx],
                      transform:
                        it.value / amount > 0.666
                          ? 'rotate(45deg)'
                          : `rotate(${
                              225 - (180 * (it.value / amount)) / 0.666
                            }deg)`,
                    }"
                  ></div>
                </div>
                <div>
                  <div
                    :style="{
                      width: boxWidth * 0.2 * (4 - idx) + 'px',
                      height: boxWidth * 0.2 * (4 - idx) + 'px',
                      borderRightColor: borderColorList[idx],
                      transform:
                        it.value / amount > 0.666
                          ? `rotate(${
                              135 - (90 * (it.value / amount - 0.666)) / 0.333
                            }deg)`
                          : 'rotate(145deg)',
                    }"
                  ></div>
                </div>
              </div>

              <div class="payName" :style="{ top: boxWidth * 0.05 + 'px' }">
                <div
                  v-for="(item, index) in payList"
                  :key="index"
                  :style="{ height: boxWidth * 0.1 + 'px' }"
                >
                  <div :style="{ background: borderColorList[index] }"></div>
                  {{ item.name }}
                </div>
              </div>
            </div>

            <div>
              <div v-for="(item, index) in payList" :key="index">
                <div :style="{ background: borderColorList[index] }"></div>
                {{ ((item.value / amount) * 100).toFixed(2) }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <div>
          <div>
            <img src="../assets/icon01.png" alt="" />
            <div>
              <div>总交易额</div>
              <div>{{money.toFixed(2)}}</div>
            </div>
          </div>
          <div>
            <img src="../assets/icon02.png" alt="" />
            <div>
              <div>柜机总数</div>
              <div>{{ deviceNum }}</div>
            </div>
          </div>
          <div>
            <img src="../assets/icon03.png" alt="" />
            <div>
              <div>今日交易额</div>
              <!-- <div>今日交易</div> -->
              <div>{{toDayMoney.toFixed(2)}}</div>
            </div>
          </div>
          <div>
            <img src="../assets/icon04.png" alt="" />
            <div>
              <div>订单总数</div>
              <div>{{ order }}</div>
            </div>
          </div>
        </div>

        <div>
          <div id="mapFather">
            <div id="map"></div>
          </div>
        </div>

        <div>
          <div>
            <div class="tit">
              <div></div>
              设备投放统计
            </div>
            <!-- <div id="place" style="overflow: hidden"></div> -->
            <div id="place"></div>
          </div>

          <div>
            <div class="tit">
              <div></div>
              支付趋势
            </div>
            <!-- <div id="howPay" style="overflow: hidden"></div> -->
            <div id="howPay"></div>
          </div>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="tit">
            <div></div>
            机器销量排行(月)
          </div>

          <div class="scrollBox">
            <div v-for="(item, index) in deviceNumList" :key="index">
              <div>
                <div>{{ index + 1 }}</div>
                {{ item.miAlias }}
              </div>
              <div>{{ item.saleAccount }}</div>
            </div>

            <div v-for="(item, index) in deviceNumList" :key="item.mId">
              <div>
                <div>{{ index + 1 }}</div>
                {{ item.miAlias }}
              </div>
              <div>{{ item.saleAccount }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="tit">
            <div></div>
            商品销量排行(月)
          </div>

          <div class="scrollBox">
            <div v-for="(item, index) in shopNumList" :key="index">
              <div>
                <div>{{ index + 1 }}</div>
                {{ item.productName }}
              </div>
              <div>{{ item.saleAccount }}</div>
            </div>

            <div v-for="(item, index) in shopNumList" :key="item.saleAccount">
              <div>
                <div>{{ index + 1 }}</div>
                {{ item.productName }}
              </div>
              <div>{{ item.saleAccount }}</div>
            </div>
          </div>
        </div>
        <div>
          <div class="tit">
            <div></div>
            设备类型分布
          </div>
          <div id="type"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- <script type="text/javascript" src="//cdn.jsdelivr.net/npm/eruda"></script> -->
<!-- <script type="text/javascript" src="http://eruda.liriliri.io/eruda.min.js" async></script> -->

<script>
import "../../src/assets/js/flexble.js";
import * as echarts from "echarts";
// import mapDot from '../common/hsxsnMapDot.js'
import mapDot from '../common/hsMapDot.js'
import eruda from 'eruda'

import { HTTP_REQUEST_URL, COMMON_TITLE } from '/config.js'
let that;
export default {
  components: {},
  data() {
    return {
			tenantId: "",
			title: COMMON_TITLE,
      cityList: [],
      boxWidth: "",
      mapChart: "",
      deviceNumList: [],
      shopNumList: [],
      toDayOrder: 0,
      toDayMoney: 0,
      order: 0,
      money: 0,
      deviceNum: "",
      payList: [],
      amount: 0,
      borderColorList: ["#1191FF", "#0FEBE2", "#FFA500", "#FF5110"],
			callCount: 0,
			lastCallTime: 0
    };
  },
  mounted() {
		// eruda.init()
    that = this;
    this.cityList = this.dealWithData();
    this.getMapData();
    this.getMap();
    this.getDeviceNum();
    this.getShopNum();
    this.F5()
    setInterval(this.F5,300000)
  },
  methods: {
    getMapData() {
      const signalR = require("@aspnet/signalr");

      var connection = new signalR.HubConnectionBuilder()
        .withUrl(`${HTTP_REQUEST_URL}/messageHub`, {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .build();

      connection.on("PayFinishedMessage", function (message) {
        let res = JSON.parse(message);
        that.cityList.forEach((element) => {
          if (res?.CityName.includes(element.name)) {
            that.change(element.value, res.ProductImageUrl);
            that.order +=1
            that.numFun(res.Amount)
          }
        });
      });
      connection.onclose(async () => {
        await start();
      });
      async function start() {
        try {
          await connection.start();
          // console.log("connected");
        } catch (err) {
          // console.log("error");
          setTimeout(() => start(), 5000);
        }
      }

      start();
    },
    change([x, y], img) {
			const currentTime = Date.now();
			 if (currentTime - this.lastCallTime < 3000) {
			    if (this.callCount >= 2) {
			      // console.log("调用频率超过限制");
			      return;
			    }
			  } else {
			    this.callCount = 0;
			  }
			  this.callCount++;
			  this.lastCallTime = currentTime;
      let mapFather = document.getElementById("mapFather");
      let box = document.createElement("div");
      box.style.backgroundImage = `url("${HTTP_REQUEST_URL}${img}")`;
      box.classList.add("donghua");
      box.style.left = ((x - 67.7) / 74.6) * 100 + "%";
      box.style.top = (1 - (y - 17.8) / 36.4) * 100 + "%";
      mapFather.appendChild(box);

      setTimeout(() => {
        mapFather.removeChild(box);
      }, 2300);
    },
    getMap() {
      that.mapChart = echarts.init(document.getElementById("map"));
      that.mapChart.setOption({
        tooltip: {
          show: false,
        },
        geo: {
          map: "china",
          roam: false, // 一定要关闭拖拽
          zoom: 1,
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          center: [105, 36], // 调整地图位置
          boundingCoords: [
            // 定位左上角经纬度
            [67.7, 54.2],
            // 定位右下角经纬度
            [142.3, 17.8],
          ],
          label: {
            normal: {
              show: false, //关闭省份名展示
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              areaColor: "#0E1972",
              borderColor: "#1C1AEA",
              borderWidth: 2, //设置外层边框
            },
            emphasis: {
              areaColor: "#184cff",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 5,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            type: "map",
            map: "china",
            roam: false,
            zoom: 1,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            center: [105, 36],
            boundingCoords: [
              // 定位左上角经纬度
              [67.7, 54.2],
              // 定位右下角经纬度
              [142.3, 17.8],
            ],
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff",
                },
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#0d0059",
                borderColor: "#389dff",
                borderWidth: 0.5,
              },
              emphasis: {
                areaColor: "#17008d",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 5,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
      var option = {
        series: [
          {
            name: "aaa",
            type: "scatter",
            coordinateSystem: "geo",
            data: this.cityList,
            symbolSize: 8,
            tooltip: {
              formatter(value) {
                return value.data.name + "<br/>" + "设备数：" + "";
              },
              show: true,
            },
            encode: {
              value: 2,
            },
            label: {
              formatter: "{b}",
              position: "right",
              show: false,
            },
            itemStyle: {
              color: "#0efacc",
            },
            emphasis: {
              label: {
                show: false,
              },
            },
          },
        ],
      };
      that.mapChart.setOption(option);
    },
    getHowPay() {
      this.$http('/dataCenter/api/tenantDataCenter/getTradeDataTrend',{},res=>{
        console.log('支付趋势',res)
				try{
					let myChart = echarts.init(document.getElementById("howPay"));
					let dataAxis = [];
					let data = [];
					let lineData = [];
					  res.data.forEach((item,index)=>{
					    dataAxis.push(item.date)
					    data.push(item.saleAmount)
					    lineData.push(item.saleAccount);
					  })
						const textStyle = {
						  color: "#00F0FD",
						  fontSize: 6
						};
						
						myChart.setOption({
						  grid: {
						    left: 30,
						    right: 25,
						    top: 25,
						    bottom: 35,
						    containLabel: true
						  },
						  xAxis: [
						    {
						      type: "category",
						      axisLabel: {
						        textStyle,
						        interval: 0 // 横轴信息全部显示
						      },
						      data: dataAxis,
						      axisLine: { // x轴线样式设置
						        show: true,
						        lineStyle: {
						          color: "#344054",
						          width: 1
						        }
						      },
						      axisTick: {
						        show: false
						      }
						    }
						  ],
						  yAxis: {
						    axisLabel: {
						      textStyle
						    },
						    splitLine: {
						      show: true,
						      lineStyle: {
						        color: "#344054",
						        width: 1
						      }
						    },
						    axisTick: {
						      show: false
						    }
						  },
						  dataZoom: [ // 缩放类型
						    {
						      type: "inside" // 内置型：通过鼠标滚轮和拖拽操作
						    }
						  ],
						  series: [
						    {
						      name: "销售额",
						      type: "line",
						      smooth: true, // 设置为平滑曲线
						      symbol: "circle",
						      symbolSize: 6,
						      itemStyle: {
						        normal: {
						          color: "#00FEED",
						          borderWidth: 2,
						          borderColor: "rgba(0, 254, 237, 0.5)"
						        }
						      },
						      lineStyle: {
						        normal: {
						          color: "#00FEED",
						          width: 2,
						          shadowColor: "rgba(0, 254, 237, 0.5)",
						          shadowBlur: 10,
						          shadowOffsetY: 5
						        }
						      },
						      areaStyle: {
						        normal: {
						          // 从曲线往X轴方向渐变，颜色透明度逐渐降低
						          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
						            { offset: 0, color: "rgba(0, 254, 237, 0.7)" }, // 曲线处颜色较深
						            { offset: 0.3, color: "rgba(0, 254, 237, 0.4)" },
						            { offset: 0.6, color: "rgba(0, 254, 237, 0.2)" },
						            { offset: 1, color: "rgba(0, 254, 237, 0)" }     // X轴处完全透明
						          ])
						        }
						      },
						      data: data,
									label: {
									  show: true,
									  distance: 4, // 标签与数据点的距离
									  backgroundColor: function(params) {
									    // 根据系列使用不同的背景色
									    return params.seriesIndex === 0 ? 'rgba(0, 240, 253, 0.8)' : 'rgba(255, 107, 107, 0.8)';
									  },
									  borderColor: '#111E3C',
									  borderWidth: 0.5,
									  padding: [3, 5],
									  borderRadius: 4,
									  formatter: function(params) {
									    // 格式化数值（保留两位小数）
									    const value =  typeof params.value === 'number' ? params.value.toFixed(2) : params.value;
											return `${value}`
									  },
									  textStyle: {
									    color: '#FFFFFF',
									    fontSize: 6,
									    fontWeight: 'bold'
									  },
									},
						    },
						    {
						      name: "销售数量",
						      type: "line",
						      smooth: true,
						      symbol: "circle",
						      symbolSize: 4,
						      itemStyle: {
						        normal: {
						          color: "#F8A52C"
						        }
						      },
						      lineStyle: {
						        normal: {
						          color: "#F8A52C",
						          width: 1.5,
						          type: "dashed"
						        }
						      },
						      areaStyle: {
						        normal: {
						          // 参考曲线的渐变区域
						          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
						            { offset: 0, color: "rgba(248, 165, 44, 0.5)" },
						            { offset: 0.5, color: "rgba(248, 165, 44, 0.2)" },
						            { offset: 1, color: "rgba(248, 165, 44, 0)" }
						          ])
						        }
						      },
						      data: lineData
						    }
						  ]
						});
				}catch(err){
					document.getElementById("howPay").innerHTML= JSON.stringify(err.message)
				}
      
      })
    },
    getPay() {
      let box = document.getElementById("pay").children[0];
      this.boxWidth = box.offsetHeight;
      box.style.width = box.offsetHeight + "px";
      this.$http(
        "/dataCenter/api/tenantDataCenter/getTopPayTypeData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          let amount = 0;
          let payList = res.data.map((item, index) => {
            amount += Number(item.saleAmount);
            return { value: item.saleAmount, name: item.payTypeName };
          });
          this.payList = payList;
          this.amount = amount;
        }
      );
    },
    getPlace() {
      this.$http("/dataCenter/api/tenantDataCenter/getTopSceneData", { tenantId: this.tenantId },
        (res) => {
          console.log('设备投放',res);
          let placeTopList = res.data.map((item, index) => {
            return { value: item.saleAmount, name: item.sceneName };
          });
          let box = document.getElementById("place");
          // console.log(box.offsetHeight);
					try{
						let myChart = echarts.init(box);
							myChart.setOption({
								color: [
									"#6BB136",
									"#00AEA5",
									"#D84646",
									"#FAEDD6",
									"#FDC343",
									"#038cc4",
									"#75abd0",
									"#afd6dd",
								],
								graphic: {
									elements: [
										{
											type: "image",
											style: {
												image: require("../assets/cbg.png"),
												width: box.offsetHeight * 0.5,
												height: box.offsetHeight * 0.5,
											},
											left: "center",
											top: "center",
										},
									],
								},
								series: [
									{
										name: "投放统计",
										type: "pie",
										// center: ["10%","10%"],
										radius: ["60%", "73%"],
										data: placeTopList,
										itemStyle: {
											borderWidth: 5, //设置border的宽度有多大
											borderColor: "rgb(4, 13, 50)",
											borderRadius: "60%",
										},
										label: {
											normal: {
												formatter: '{b|{b}}\n\n',
												borderWidth: 20,
												borderRadius: 4,
												padding: [0, -70],
												rich: {
													a: {
															color: '#333',
															fontSize: 12,
															lineHeight: 20
													},
													b: {
															fontSize: 8,
															lineHeight: 20,
															color: '#fff'
													}
												}
											}
											//color: "#fff",
											// fontSize: 6
										},
										labelLine: { show: false },
									},
								],
						 });
					}catch(err){
						box.innerHTML= JSON.stringify(err.message)
					}
          
					
					
        }
      );
    },
    getDeviceTop() {
      this.$http(
        "/dataCenter/api/tenantDataCenter/getTopMachineData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          let dataAxis = [];
          let data = [];
          for (let i = 0; i < 10; i++) {
            dataAxis.unshift(res.data[i].miAlias);
            data.unshift(res.data[i].saleAmount);
          }

          let myChart = echarts.init(document.getElementById("deviceTop"));

          myChart.setOption({
            grid: {
              x: 25,
              x2: 25,
              y: 10,
              y2: 10,
              left: 80,
							// containLabel: true
            },
            xAxis: [
              {
                type: "value",
                axisLabel: {
                  show: false,
                },
                offset: 10,
                splitLine: {
                  show: false,
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
							
              },
            ],
            yAxis: {
              type: "category",
              data: dataAxis,
              boundaryGap: false,
              axisLabel: {
                textStyle: {
                  color: "#0096FF",
                  fontSize: 6, // Y轴字体大小
                },
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
            },
            dataZoom: [
              {
                type: "inside",
              },
            ],
            series: [
              {
                type: "bar",
                barWidth: 6, //柱图宽度
                itemStyle: {
                  normal: {
                    barBorderRadius: 12,
                    color: function (params) {
                      var colorlist = [
                        "#35AAF6",
                        "#35AAF6",
                        "#35AAF6",
                        "#35AAF6",
                        "#35AAF6",
                        "#35AAF6",
                        "#00ff77",
                        "#FBC300",
                        "#E67716",
                        "#DA251D",
                      ];
                      return colorlist[params.dataIndex];
                    },
                    label: {
                      show: true,
                      position: "right",
                      textStyle: {
                        color: "#00F0FD",
												fontSize: 6 // 设备top10 右侧字体大小
                      },
                      formatter: function (params) {
                        if (params.value == 0) {
                          return "";
                        } else {
                          return params.value;
                        }
                      },
                    },
                  },
                },
                data: data,
              },
            ],
          });
        }
      );
    },
    getShopTop() {
      this.$http(
        "/dataCenter/api/tenantDataCenter/getTopProductData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          let dataAxis = [];
          let data = [];
          for (let i = 0; i < 5; i++) {
            dataAxis.push(res.data[i].productName);
            data.push(res.data[i].saleAmount);
          }

          let myChart = echarts.init(document.getElementById("shopTop"));

          myChart.setOption({
            grid: {
              x: 25,
              x2: 25,
              y: 25,
              y2: 35,
              left: 40,
							containLabel: true //高度自适应
            },
            xAxis: [
              {
                type: "category",
                axisLabel: {
                  textStyle: {
                    color: "#00F0FD",
                    fontSize: 6,
                  },
                  interval: 0, // 横轴信息全部显示
									// rotate: 20, // 倾斜文字
									
									// 文字逢四换行
									formatter: function (params){
										var str = '';
										for(var i=0; i<params.length; i++){
											if(i % 4 == 0 && i !=0){
												str += '\n' + params[i]
											}else{
												str += params[i]
											}
										}
										return str
									}
                },
                offset: 10,
                //  boundaryGap: false,
                splitLine: {
                  show: false,
                },
                data: dataAxis,
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            yAxis: {
              axisLabel: {
                textStyle: {
                  color: "#00F0FD",
                  fontSize: 6,
                },
              },
              splitLine: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
            },
            dataZoom: [
              {
                type: "inside",
              },
            ],
            series: [
              {
                type: "bar",
                barWidth: 10, //柱图宽度
                itemStyle: {
                  normal: {
                    barBorderRadius: 12,
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "#00F0FD", // 0% 处的颜色
                        },
                        {
                          offset: 1,
                          color: "#000D9C", // 100% 处的颜色
                        },
                      ],
                      globalCoord: true, // 缺省为 false
                    },
                    label: {
                      show: true,
                      position: "top",
                      textStyle: {
                        color: "#00F0FD",
												fontSize: 6
                      },
                      formatter: function (params) {
                        if (params.value == 0) {
                          return "";
                        } else {
                          return params.value;
                        }
                      },
                    },
                  },
                },
                data: data,
              },
            ],
          });
        }
      );
    },
    getDeviceNum() {
      this.$http(
        "/dataCenter/api/tenantDataCenter/getTopMachineAccountData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          this.deviceNumList = res.data;
          this.setScroll(0, 20);
        }
      );
    },
    getShopNum() {
      this.$http(
        "/dataCenter/api/tenantDataCenter/getTopProductAccountData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          this.shopNumList = res.data;
					// const modifiedData = res.data.map(item => {
					//     if (item.productName.startsWith("PP")) {
					//         return { ...item, productName: ">PP<替换名称" };
					//     }
					//     return item;
					// });
					// this.shopNumList = modifiedData
          this.setScroll(1, 20);
        }
      );
    },
    getDeviceType() {
      // this.$http(
      //   "/dataCenter/api/tenantDataCenter/getTopSceneData",
      //   {
      //     tenantId: this.tenantId,
      //   },
      //   (res) => {
      //     console.log(res);
      //     let placeTopList = res.data.map((item, index) => {
      //       return { value: item.saleAmount, name: item.sceneName };
      //     });

      //   }
      // );

      let myChart = echarts.init(document.getElementById("type"));
      let dataAxis = ["牛奶机", "消费扶贫专柜", "饮料机", "综合机", "其他"];
      // let data = [20, 20, 25, 30, 5];
      // let data1 = [21, 21, 26, 31, 6];
      let data = [70, 5, 15, 5, 5];
      let data1 = [71, 6, 16, 6, 6];

      myChart.setOption({
        grid: {
          x: 25,
          x2: 25,
          y: 25,
          y2: 35,
          left: 40,
        },
        xAxis: [
          {
            type: "category",
            axisLabel: {
              textStyle: {
                color: "#00F0FD",
                fontSize: 6,
              },
              interval: 0, //横轴信息全部显示
							// 文字逢四换行
							formatter: function (params){
								var str = '';
								for(var i=0; i<params.length; i++){
									if(i % 4 == 0 && i !=0){
										str += '\n' + params[i]
									}else{
										str += params[i]
									}
								}
								return str
							}
            },
            offset: 10,
            //  boundaryGap: false,
            splitLine: {
              show: false,
            },
            data: dataAxis,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#02356B",
                width: 1,
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: {
          axisLabel: {
            textStyle: {
              color: "#00F0FD",
              fontSize: 6,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#344054",
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#02356B",
              width: 1,
            },
          },
          axisTick: {
            show: false,
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            // barWidth: 15, //柱图宽度
            barWidth: 6, //柱图宽度
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#16B5FF", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000D9C", // 100% 处的颜色
                    },
                  ],
                  globalCoord: true, // 缺省为 false
                },
                label: {
                  show: true,
                  position: [2, -10],
                  textStyle: {
                    color: "#00F0FD",
										fontSize: 6
                  },
                  formatter: function (params) {
                    if (params.value == 0) {
                      return "";
                    } else {
                      return params.value;
                    }
                  },
                },
              },
            },
            data: data,
          },
          {
            type: "bar",
            // barWidth: 6, //柱图宽度
            barWidth: 4, //柱图宽度
            barGap: 0,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#16B5FF", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#000D9C", // 100% 处的颜色
                    },
                  ],
                  globalCoord: true, // 缺省为 false
                },
                label: {
                  show: false,
                  formatter: function (params) {
                    if (params.value == 0) {
                      return "";
                    } else {
                      return params.value;
                    }
                  },
                },
              },
            },
            data: data1,
          },
          {
            tooltip: {
              show: false,
            },
            type: "pictorialBar",
            itemStyle: {
              borderWidth: 1,
              borderColor: "#0571D5",
              color: "#1779E0",
            },
            symbol: "path://M 0,0 l 120,0 l -30,60 l -120,0 z",
            // symbolSize: ["25.9", "7"],
            symbolSize: ["10", "2"],
            // symbolOffset: ["-0.1", "-7"],
            symbolOffset: ["0", "-2"],
            symbolRotate: 0,
            symbolPosition: "end",
            data: data,
            z: 3,
          },
        ],
      });
    },
    getCenterTop() {
      this.$http(
        "/dataCenter/api/tenantDataCenter/getDayTradeData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
					const { saleAccount=0, saleAmount=0 } = res?.data || {}
          this.toDayOrder = saleAccount || 0;
          this.toDayMoney = saleAmount || 0;
        }
      );

      this.$http(
        "/dataCenter/api/tenantDataCenter/getYearTradeData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
					const { saleAccount=0, saleAmount=0 } = res?.data || {}
          this.order = saleAccount || 0;
          this.money = saleAmount || 0;
        }
      );

      this.$http(
        "/dataCenter/api/tenantDataCenter/getSumMachineCountData",
        {
          tenantId: this.tenantId,
        },
        (res) => {
          this.deviceNum = res.data.value;
        }
      );
    },
    dealWithData() {
			let geoCoordMap = mapDot
      var data = [];
      for (var key in geoCoordMap) {
        data.push({ name: key, value: geoCoordMap[key] });
      }
      return data;
    },
    setScroll(x) {
      let box = document.getElementsByClassName("scrollBox")[x];
      window.onmousewheel = box.onmousewheel=function() {return false}
      let mytimer;
      let myScrollTop = box.scrollTop
      function scrollUp() {
        if (box.scrollTop >= box.offsetHeight * 2.4 - 1) {
          myScrollTop = 0
          box.scrollTop = myScrollTop;
          mytimer = requestAnimationFrame(scrollUp);
        } else {
          myScrollTop += 0.5
          if(myScrollTop%1==0){box.scrollTop = myScrollTop}
          mytimer = requestAnimationFrame(scrollUp);
        }
      }
      box.onmouseover = function () {
        cancelAnimationFrame(mytimer);
      };
      box.onmouseout = function () {
        scrollUp();
      };
      scrollUp();
    },
    numFun(x){
      let add = x
      let mytimer;
      let num = (add/30)
      let flag = true
      // console.log(add/30)
        function changeNum(){
          if(flag){
            that.toDayMoney += num
          that.money += num
          add -= num
        if(add>num){
        mytimer = requestAnimationFrame(changeNum);
        }else{
          that.toDayMoney += add
          that.money += add

        cancelAnimationFrame(mytimer);
          }
          
        }else{
          flag = true
        mytimer = requestAnimationFrame(changeNum);

        }
        }
        mytimer = requestAnimationFrame(changeNum);
       
        
    },
    F5(){
			this.getCenterTop();
			this.getHowPay();
			this.getPlace();
			this.getPay();
			this.getDeviceType();
			this.getDeviceTop();
			this.getShopTop();
    }
  },
};
</script>

<style lang="less">
@keyframes donghua {
  0% {
    transform: rotateY(180deg) scale(3);
  }
  45% {
    transform: rotateY(0deg) scale(3);
  }
  100% {
    transform: scale(0.8); //0.8
  }
}
body{
  user-select:none;
}
.tit {
  font-size: .2rem /* 16/80 */;
  color: #00d8ff;
  font-weight: 700;
  height: .25rem /* 20/80 */;
  line-height: .25rem /* 20/80 */;
  display: flex;
  letter-spacing: .0375rem /* 3/80 */x;
  > div {
    background: #00d8ff;
    height: 100%;
    width: 6px;
    margin-right: .125rem /* 10/80 */;
  }
}
.content {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}
.nav {
  width: 100%;
  height: 8%;
  background: url(../assets/titbg.png) center center/100% 100% rgb(4, 13, 50);
  > div {
    margin: 0 auto;
    width: 50%;
    text-align: center;
    font-size: .4rem /* 32/80 */;
    height: 8vh;
    line-height: 8vh;
    background-image: -webkit-linear-gradient(bottom, #00b6ff, #ffffff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }
}
.main {
  background: url(../assets/zbg.png) center center/100% 100%;
  width: 100%;
  height: 92%;
  display: flex;
  overflow: hidden;
  > div {
    height: 100%;
  }
  > div.left {
    width: 22.5%;
    width: 30.5%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    > div {
      padding: 0 1.5vw;
      overflow: hidden;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: .25rem /* 20/80 */ auto;
      > div:last-child {
        margin: .25rem /* 20/80 */ 0;
      }
    }
    > div:last-child > div:last-child {
      position: relative;
      > div:first-child {
        height: 100%;
        position: relative;
      }
      > div:last-child {
        position: absolute;
        bottom: 0;
        // right: 40px;
        // right: .125rem /* 10/80 */;
        right: 2rem /* 10/80 */;
        font-size: .15rem /* 12/80 */;
        color: #ffffff;
        > div {
          display: flex;
          align-items: center;
          height: .375rem /* 30/80 */;
          width: 100%;
          > div {
            width: .1rem /* 8/80 */;
            height: .1rem /* 8/80 */;
            border-radius: 50%;
            margin-right: .1875rem /* 15/80 */;
          }
        }
      }
      > div > div.payName {
        position: absolute;
        font-size: .15rem /* 12/80 */;
        color: #ffffff;
        left: 50%;
        margin-left: .125rem /* 10/80 */;
        margin-top: .03125rem /* 2.5/80 */;
        > div {
          display: flex;
          align-items: center;
          > div {
            width: .0625rem /* 5/80 */;
            height: .0625rem /* 5/80 */;
            border-radius: 50%;
            margin-right: .1875rem /* 15/80 */;
          }
        }
      }
    }
  }
  > div.center {
    width: 55%;
    box-sizing: border-box;
    color: #ffffff;
    padding-top: .375rem /* 30/80 */;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 8vh 52vh auto;
    > div {
      box-sizing: border-box;
    }
    > div:nth-child(1) {
      height: 8vh;
      display: flex;
      justify-content: center;
      text-align: center;
      > div {
        background-color: rgb(1, 16, 83);
        // width: 18%;
        width: 20%;
        margin: 0 .125rem /* 10/80 */;
        position: relative;
        box-sizing: border-box;
        border: 1px solid rgb(78, 206, 235);
        height: 8vh;
        display: flex;
        align-items: center;
        > img {
          width: 6vh;
          height: 6vh;
          margin-left: .1rem /* 8/80 */;
        }
        > div {
          height: 100%;
          width: calc(100% - 7vh - 16px);
          text-align: center;
          > div {
            width: 100%;
            height: 50%;
          }
          > div:first-child {
            font-size: .175rem /* 14/80 */;
            color: #0096ff;
            line-height: 5vh;
          }
          > div:last-child {
            font-size: .2rem /* 16/80 */;
            font-weight: 600;
            color: #ffc000;
          }
        }
      }
      > div::before {
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: .125rem /* 10/80 */;
        width: calc(100% - 20px);
        content: "";
        border-top: 1px solid rgb(4, 13, 50);
        border-bottom: 1px solid rgb(4, 13, 50);
        z-index: 0;
      }
      > div::after {
        position: absolute;
        top: .125rem /* 10/80 */;
        right: -1px;
        left: -1px;
        height: calc(100% - 20px);
        content: "";
        border-right: 1px solid rgb(4, 13, 50);
        border-left: 1px solid rgb(4, 13, 50);
        z-index: 0;
      }
    }
    > div:nth-child(2) {
      height: 52vh;
      > div {
        width: 80vh;
        height: 100%;
        margin: 0 auto;
        position: relative;

        > div#map {
          width: 100%;
          height: 100%;
        }
      }
    }
    > div:nth-child(3) {
      display: flex;
      > div {
        width: 50%;
        height: 100%;
        padding: 0 0.7vw;
        overflow: hidden;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 20px auto;
        > div:last-child {
          margin: .25rem /* 20/80 */ 0;
        }
      }
    }
  }
  > div.right {
    width: 22.5%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    color: #ffffff;
    overflow: hidden;
    > div {
      padding: 0 0.7vw;
      overflow: hidden;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: .25rem /* 20/80 */ auto;
      > div:last-child {
        overflow: scroll;
        box-sizing: border-box;
        scrollbar-width: none;
        margin: .25rem /* 20/80 */ 0;
        > div {
          display: flex;
          justify-content: space-between;
          height: 12%;
          align-items: center;
          font-size: .15rem /* 12/80 */;
          padding: 0 .625rem /* 50/80 */ 0 .25rem /* 20/80 */;

          > div:first-child {
            display: flex;
            align-items: center;
            color: #dddddd;

            > div {
              width: .1875rem /* 15/80 */;
              height: .1875rem /* 15/80 */;
              background: #878787;
              line-height: .1875rem /* 15/80 */;
              text-align: center;
              margin-right: .25rem /* 20/80 */;
              border-radius: 3px;
            }
          }
        }

        > div:nth-child(1) > div:first-child > div,
        > div:nth-child(21) > div:first-child > div {
          background: #ed405d;
        }
        > div:nth-child(2) > div:first-child > div,
        > div:nth-child(22) > div:first-child > div {
          background: #ff8b3d;
        }
        > div:nth-child(3) > div:first-child > div,
        > div:nth-child(23) > div:first-child > div {
          background: #45c0ff;
        }
      }
    }
  }
}
.donghua {
  width: 1vw;
  height: 1vw;
  background-color: #ffffff;
  background-position: center center;
  background-size: 90% 90%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 10000;
  margin: -0.5vw 0 0 -0.5vw;
  border-radius: 50%;
  animation: donghua 2.4s;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.box > div.bg {
  width: 100%;
  height: 100%;
  border: 5px solid #03305b;
  border-right: 5px solid transparent;
  border-radius: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
}
div.box > .bg::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  bottom: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-bottom: -0.75px;
}
div.box > .bg:nth-child(1)::before {
  background: #1191ff;
}
div.box > .bg:nth-child(2)::before {
  background: #0febe2;
}
div.box > .bg:nth-child(3)::before {
  background: #ffa500;
}
div.box > .bg:nth-child(4)::before {
  background: #ff5110;
}
div.box > .bg::after {
  content: "";
  position: absolute;
  background: #03305b;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  top: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-top: -0.75px;
}
.box > div.border {
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
}
.box > div.border > div {
  position: absolute;
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.box > div.border > div:nth-child(2) {
  right: 0;
}
.box > div.border > div > div {
  height: 100%;
  border: 5px solid transparent;
  border-radius: 50%;
  box-sizing: border-box;
}
.box > div.border > div:first-child > div {
  border-left: 5px solid rgba(0, 0, 0, 0);
  border-bottom: 5px solid rgba(0, 0, 0, 0);
  transform: rotate(224deg);
  transition: all 1s linear;
}
.box > div.border > div:first-child > div::after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  top: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-top: -0.75px;
}
.box > div.border:nth-child(5) > div:first-child > div::after {
  background: #1191ff;
}
.box > div.border:nth-child(6) > div:first-child > div::after {
  background: #0febe2;
}
.box > div.border:nth-child(7) > div:first-child > div::after {
  background: #ffa500;
}
.box > div.border:nth-child(8) > div:first-child > div::after {
  background: #ff5110;
}
.box > div.border > div:last-child > div {
  position: absolute;
  right: 0;
  border-right: 5px solid rgba(0, 0, 0, 0);
  transform: rotate(145deg);
}
.box > div.border > div:last-child > div::after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  bottom: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-bottom: -0.75px;
}
.box > div.border:nth-child(5) > div:last-child > div::after {
  background: #1191ff;
}
.box > div.border:nth-child(6) > div:last-child > div::after {
  background: #0febe2;
}
.box > div.border:nth-child(7) > div:last-child > div::after {
  background: #ffa500;
}
.box > div.border:nth-child(8) > div:last-child > div::after {
  background: #ff5110;
}

// #mapFather{
//   border: 1px solid #fff;
// }
</style>


<!-- <style lang="less">
@keyframes donghua {
  0% {
    transform: rotateY(180deg) scale(3);
  }
  45% {
    transform: rotateY(0deg) scale(3);
  }
  100% {
    transform: scale(0.8); //0.8
  }
}
body{
  user-select:none;
}
.tit {
  font-size: 16px;
  color: #00d8ff;
  font-weight: 700;
  height: 20px;
  line-height: 20px;
  display: flex;
  letter-spacing: 3px;
  > div {
    background: #00d8ff;
    height: 100%;
    width: 6px;
    margin-right: 10px;
  }
}
.content {
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
}
.nav {
  width: 100%;
  height: 8%;
  background: url(../assets/titbg.png) center center/100% 100% rgb(4, 13, 50);
  > div {
    margin: 0 auto;
    width: 50%;
    text-align: center;
    font-size: 32px;
    height: 8vh;
    line-height: 8vh;
    background-image: -webkit-linear-gradient(bottom, #00b6ff, #ffffff);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }
}
.main {
  background: url(../assets/zbg.png) center center/100% 100%;
  width: 100%;
  height: 92%;
  display: flex;
  overflow: hidden;
  > div {
    height: 100%;
  }
  > div.left {
    width: 22.5%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    > div {
      padding: 0 1.5vw;
      overflow: hidden;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 20px auto;
      > div:last-child {
        margin: 20px 0;
      }
    }
    > div:last-child > div:last-child {
      position: relative;
      > div:first-child {
        height: 100%;
        position: relative;
      }
      > div:last-child {
        position: absolute;
        bottom: 0;
        // right: 40px;
        right: 10px;
        font-size: 12px;
        color: #ffffff;
        > div {
          display: flex;
          align-items: center;
          height: 30px;
          width: 100%;
          > div {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            margin-right: 15px;
          }
        }
      }
      > div > div.payName {
        position: absolute;
        font-size: 12px;
        color: #ffffff;
        left: 50%;
        margin-left: 10px;
        margin-top: 2.5px;
        > div {
          display: flex;
          align-items: center;
          > div {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            margin-right: 15px;
          }
        }
      }
    }
  }
  > div.center {
    width: 55%;
    box-sizing: border-box;
    color: #ffffff;
    padding-top: 30px;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 8vh 52vh auto;
    > div {
      box-sizing: border-box;
    }
    > div:nth-child(1) {
      height: 8vh;
      display: flex;
      justify-content: center;
      text-align: center;
      > div {
        background-color: rgb(1, 16, 83);
        // width: 18%;
        width: 20%;
        margin: 0 10px;
        position: relative;
        box-sizing: border-box;
        border: 1px solid rgb(78, 206, 235);
        height: 8vh;
        display: flex;
        align-items: center;
        > img {
          width: 6vh;
          height: 6vh;
          margin-left: 8px;
        }
        > div {
          height: 100%;
          width: calc(100% - 7vh - 16px);
          text-align: center;
          > div {
            width: 100%;
            height: 50%;
          }
          > div:first-child {
            font-size: 14px;
            color: #0096ff;
            line-height: 5vh;
          }
          > div:last-child {
            font-size: 16px;
            font-weight: 600;
            color: #ffc000;
          }
        }
      }
      > div::before {
        position: absolute;
        top: -1px;
        bottom: -1px;
        left: 10px;
        width: calc(100% - 20px);
        content: "";
        border-top: 1px solid rgb(4, 13, 50);
        border-bottom: 1px solid rgb(4, 13, 50);
        z-index: 0;
      }
      > div::after {
        position: absolute;
        top: 10px;
        right: -1px;
        left: -1px;
        height: calc(100% - 20px);
        content: "";
        border-right: 1px solid rgb(4, 13, 50);
        border-left: 1px solid rgb(4, 13, 50);
        z-index: 0;
      }
    }
    > div:nth-child(2) {
      height: 52vh;
      > div {
        width: 80vh;
        height: 100%;
        margin: 0 auto;
        position: relative;

        > div#map {
          width: 100%;
          height: 100%;
        }
      }
    }
    > div:nth-child(3) {
      display: flex;
      > div {
        width: 50%;
        height: 100%;
        padding: 0 0.7vw;
        overflow: hidden;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 20px auto;
        > div:last-child {
          margin: 20px 0;
        }
      }
    }
  }
  > div.right {
    width: 22.5%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    color: #ffffff;
    overflow: hidden;
    > div {
      padding: 0 0.7vw;
      overflow: hidden;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 20px auto;
      > div:last-child {
        overflow: scroll;
        box-sizing: border-box;
        scrollbar-width: none;
        margin: 20px 0;
        > div {
          display: flex;
          justify-content: space-between;
          height: 12%;
          align-items: center;
          font-size: 12px;
          padding: 0 50px 0 20px;

          > div:first-child {
            display: flex;
            align-items: center;
            color: #dddddd;

            > div {
              width: 15px;
              height: 15px;
              background: #878787;
              line-height: 15px;
              text-align: center;
              margin-right: 20px;
              border-radius: 3px;
            }
          }
        }

        > div:nth-child(1) > div:first-child > div,
        > div:nth-child(21) > div:first-child > div {
          background: #ed405d;
        }
        > div:nth-child(2) > div:first-child > div,
        > div:nth-child(22) > div:first-child > div {
          background: #ff8b3d;
        }
        > div:nth-child(3) > div:first-child > div,
        > div:nth-child(23) > div:first-child > div {
          background: #45c0ff;
        }
      }
    }
  }
}
.donghua {
  width: 1vw;
  height: 1vw;
  background-color: #ffffff;
  background-position: center center;
  background-size: 90% 90%;
  background-repeat: no-repeat;
  position: absolute;
  z-index: 10000;
  margin: -0.5vw 0 0 -0.5vw;
  border-radius: 50%;
  animation: donghua 2.4s;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.box > div.bg {
  width: 100%;
  height: 100%;
  border: 5px solid #03305b;
  border-right: 5px solid transparent;
  border-radius: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
}
div.box > .bg::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  bottom: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-bottom: -0.75px;
}
div.box > .bg:nth-child(1)::before {
  background: #1191ff;
}
div.box > .bg:nth-child(2)::before {
  background: #0febe2;
}
div.box > .bg:nth-child(3)::before {
  background: #ffa500;
}
div.box > .bg:nth-child(4)::before {
  background: #ff5110;
}
div.box > .bg::after {
  content: "";
  position: absolute;
  background: #03305b;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  top: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-top: -0.75px;
}
.box > div.border {
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: 50%;
}
.box > div.border > div {
  position: absolute;
  width: 50%;
  height: 100%;
  overflow: hidden;
}
.box > div.border > div:nth-child(2) {
  right: 0;
}
.box > div.border > div > div {
  height: 100%;
  border: 5px solid transparent;
  border-radius: 50%;
  box-sizing: border-box;
}
.box > div.border > div:first-child > div {
  border-left: 5px solid rgba(0, 0, 0, 0);
  border-bottom: 5px solid rgba(0, 0, 0, 0);
  transform: rotate(224deg);
  transition: all 1s linear;
}
.box > div.border > div:first-child > div::after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  top: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-top: -0.75px;
}
.box > div.border:nth-child(5) > div:first-child > div::after {
  background: #1191ff;
}
.box > div.border:nth-child(6) > div:first-child > div::after {
  background: #0febe2;
}
.box > div.border:nth-child(7) > div:first-child > div::after {
  background: #ffa500;
}
.box > div.border:nth-child(8) > div:first-child > div::after {
  background: #ff5110;
}
.box > div.border > div:last-child > div {
  position: absolute;
  right: 0;
  border-right: 5px solid rgba(0, 0, 0, 0);
  transform: rotate(145deg);
}
.box > div.border > div:last-child > div::after {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  z-index: 1;
  left: 85.4%;
  bottom: 85.4%;
  border-radius: 50%;
  margin-left: -0.75px;
  margin-bottom: -0.75px;
}
.box > div.border:nth-child(5) > div:last-child > div::after {
  background: #1191ff;
}
.box > div.border:nth-child(6) > div:last-child > div::after {
  background: #0febe2;
}
.box > div.border:nth-child(7) > div:last-child > div::after {
  background: #ffa500;
}
.box > div.border:nth-child(8) > div:last-child > div::after {
  background: #ff5110;
}

// #mapFather{
//   border: 1px solid #fff;
// }
</style> -->
